// extracted by mini-css-extract-plugin
module.exports = {"title":"AssignOrSubstituteModal_title__mDPK1","content":"AssignOrSubstituteModal_content__iYspR","buttons":"AssignOrSubstituteModal_buttons__HQZyj"};